/*******************************************************************************
 * Copyright (c) 2023 Belltane
 *
 * All rights reserved.
 *
 * Contributors:
 *   
 *  Amina Rais - Initial implementation
 *  Version: 1.0.0
 *
 *******************************************************************************/


import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { Grid, Typography, Button, Alert } from '@mui/material'
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { Formik, Form, Field } from 'formik'
import * as Yup from 'yup'
import { TextField } from 'formik-mui'
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { makeStyles } from 'tss-react/mui';
import { getUserInfo } from '../../../store/reducers/user/userAction';
import MainCard from '../../../ui-elements/cards/MainCard'; 
import { firebaseConfigProd } from '../../../config/firebase-prod'
import { firebaseConfigDev } from '../../../config/firebase-dev'
import { initializeApp } from 'firebase/app';

import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';


const LoginPage = () => {
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const [error, setError] = useState("")
  const app = initializeApp(process.env.REACT_APP_NODE_ENV_VAR === "PROD" ? firebaseConfigProd : firebaseConfigDev);
  const dispatch = useDispatch()

  const auth = getAuth(app);

  const handleSubmit = async (user, { setSubmitting }) => {
    const { email, password } = user

    if (email && password) {

      try {
        setLoading(true);

        await signInWithEmailAndPassword(auth, email, password);
        // Call getUserInfo and handle the response
        const userInfoAction = await dispatch(getUserInfo());
        const userInfo = userInfoAction.payload; 

        setLoading(false);
        setError("");
        setSubmitting(false);
        console.log('userInfo',userInfo.payload)
        if (userInfo && Object.keys(userInfo).length > 0) {
          // User has a profile, navigate to the dashboard
          setError("");
          navigate('/dashboard');
        } else {
          // User doesn't have a profile, handle accordingly (e.g., show message)
          setError("User doesn't have a profile.");
        } setLoading(false);
     
      } catch (err) {
        console.log('err', err);
        setSubmitting(false);
        setLoading(false);
        setError("Invalid email or password.")
      }
    }
  }

  const { classes } = useStyles();
  return (
    <>
      <Box m={6}>

        <Grid container  >
          <Grid item xs={12} sm={1} md={1} />

          <Grid item xs={12} sm={10} md={10}>
            <MainCard>

              <Grid container   >
                <Grid item xs={12} sm={12} md={3} />
                <Grid item xs={12} sm={12} md={6} >
                  <Box m={2}   >
                    <Link
                      to={"/"}
                    >
                      <img src="/assets/images/Logo/logo.png" alt="DihDah" height="150px" className='AlignCenter' />
                    </Link>
                    <Grid container >

                      <Grid item xs={12} sm={12} md={12}>
                        {error && <Alert variant="filled" color='error'>{error}</Alert>}
                        <Formik
                          initialValues={{
                            email: '',
                            password: '',
                          }}

                          validationSchema={Yup.object().shape({
                            email: Yup.string().email().required(),
                            password: Yup.string().min(8).max(30).required()

                          })}
                          onSubmit={(
                            { email, password }, { setSubmitting }
                          ) => { handleSubmit({ email, password }, { setSubmitting }) }}
                        >
                          {() => (
                            <Form>

                              <Field
                                name="email"
                                label="email"
                                type="email"
                                component={TextField}
                                margin="normal"
                                variant="outlined"
                                fullWidth
                              />


                              <Field
                                name="password"
                                label="Password"
                                type="password"
                                component={TextField}
                                margin="normal"
                                variant="outlined"
                                fullWidth
                              />

                              <Grid container spacing={6} style={{ marginTop: '20px' }}>
                                <Grid item xs={12} sm={12} md={12}>
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    size='large'
                                    type="submit"
                                    className={classes.button}
                                  >
                                    {loading && <CircularProgress className={classes.progress} color="success" size={24} />}
                                    <Typography variant='h3' color="white"> Login</Typography>

                                  </Button>
                                  <span>{'  '}</span>
                             {   process.env.REACT_APP_REGISTER_MODE === "true" &&  <Button
                                    className={classes.button} onClick={() => { navigate("/register") }}  >
                                    <Typography variant='h4'>  Sign up</Typography>
                                  </Button>}
                                </Grid>
                              </Grid>

                            </Form>

                          )}

                        </Formik>


                      </Grid>

                    </Grid>

                  </Box>

                </Grid>
              </Grid>
            </MainCard>

          </Grid>

        </Grid>
        <Grid item xs={12} sm={1} md={1} />

      </Box>
    </>
  )

}
const useStyles = makeStyles({ "name": { LoginPage } })(theme => ({
  heroContent: {
    height: 'calc( 100vh - 150px)',
  },

  button: {
    margin: theme.spacing(1),
    color: "white"
  },

  floatingLabelFocusStyle: {
    color: theme.palette.primary.main
  },
  ImgLoginDescp: {
    width: '300px',
    margin: 'auto',
    marginLeft: "auto",
    marginRight: 'auto'
  },
  containerBox: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: '10px',
    backgroundSize: '100%',
    backgroundRepeat: 'no-repeat'
  },
  BoxContainerLogin: {
    padding: '1em',
    borderRadius: '10px',
    boxShadow: 'rgb(38 127 161) 1px 5px 24px 0px',

  }
}))

export default LoginPage;
